import actionTypes from './actionTypes';

const INITIAL_STATE = {
  getUserProfileLoading: false,
  getUserProfileFailed: false,
  getUserProfileReject: false,
  getUserProfileMessage: [],
  userProfile: [],

  editUserProfileLoading: false,
  editUserProfileFailed: false,
  editUserProfileReject: false,
  editUserProfileMessage: [],
  editUserProfile: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_USER_PROFILE_LOADING: {
      return {
        ...state,
        getUserProfileLoading: true,
        getUserProfileFailed: false,
        getUserProfileReject: false,
        getUserProfileMessage: [],
        userProfile: [],
      };
    }
    case actionTypes.GET_USER_PROFILE_SUCCESS: {
      return {
        ...state,
        getUserProfileLoading: false,
        getUserProfileFailed: false,
        getUserProfileReject: false,
        getUserProfileMessage: [],
        userProfile: action.payload,
      };
    }
    case actionTypes.GET_USER_PROFILE_FAILED: {
      return {
        ...state,
        getUserProfileLoading: false,
        getUserProfileFailed: true,
        getUserProfileReject: false,
        getUserProfileMessage: [],
        userProfile: [],
      };
    }
    case actionTypes.GET_USER_PROFILE_REJECT: {
      const { message } = action.payload;
      return {
        ...state,
        getUserProfileLoading: false,
        getUserProfileFailed: false,
        getUserProfileReject: true,
        getUserProfileMessage: message,
        userProfile: [],
      };
    }

    case actionTypes.EDIT_USER_PROFILE_LOADING: {
      return {
        ...state,
        editUserProfileLoading: true,
        editUserProfileFailed: false,
        editUserProfileReject: false,
        editUserProfileMessage: [],
        editUserProfile: [],
      };
    }
    case actionTypes.EDIT_USER_PROFILE_SUCCESS: {
      return {
        ...state,
        editUserProfileLoading: false,
        editUserProfileFailed: false,
        editUserProfileReject: false,
        editUserProfileMessage: [],
        editUserProfile: action.payload,
      };
    }
    case actionTypes.EDIT_USER_PROFILE_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        editUserProfileLoading: false,
        editUserProfileFailed: true,
        editUserProfileReject: false,
        editUserProfileMessage: message,
        editUserProfile: [],
      };
    }
    case actionTypes.EDIT_USER_PROFILE_REJECT: {
      // const { message } = action.payload;
      return {
        ...state,
        editUserProfileLoading: false,
        editUserProfileFailed: false,
        editUserProfileReject: true,
        editUserProfileMessage: [],
        editUserProfile: [],
      };
    }

    default:
      return state;
  }
};
